import script from "./easiCard.vue?vue&type=script&setup=true&lang=js"
export * from "./easiCard.vue?vue&type=script&setup=true&lang=js"

import "./easiCard.vue?vue&type=style&index=0&id=b796b756&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b796b756"]])

export default __exports__